import React from 'react';

import './TextVodorovne.css';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';

const textVodorovne = (props) => {
  
    let image =  <img onClick={() => props.onShowModal(props.img)} id="VodorovneImg" src={props.img} alt="test" />;

    if (props.img2) {
      
     image = props.img2.map(image => <img onClick={() => props.onShowModal(image)} id="VodorovneImg" src={image} alt="test" />)
    }
    
return (
<div className='KurzTextVodorovneContainer'>
         {image}
         
         <div className='KurzTextVodorovne'>
            
            <h4 className='KurzTextVodorovneNadpis'>{props.name}</h4>
             
             <p>{props.text}</p>

         </div>
         
    </div>
)
}

const mapStateToProps = state => {
  
}
    const mapDispatchToProps = dispatch => {
      return {
        onShowModal: (img) => dispatch(actions.showModal(img)),
      
      }
    }


export default connect(null,mapDispatchToProps)(textVodorovne);